import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return next(withAuth(request, auth, router)).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401 || isAuthRequest(request.url)) {
        return throwError(() => error);
      }

      return auth.refreshSession().pipe(
        switchMap(() => next(withAuth(request, auth, router))),
        catchError((refreshError: unknown) => {
          auth.handleUnauthorized(router.url);
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};

function withAuth(request: HttpRequest<unknown>, auth: AuthService, router: Router) {
  const token = auth.token;
  const headers: Record<string, string> = {
    'X-Client-Route': router.url,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return request.clone({
    setHeaders: headers,
    withCredentials: true,
  });
}

function isAuthRequest(url: string) {
  const normalized = url.toLowerCase();

  return (
    normalized.includes('/account/login') ||
    normalized.includes('/account/logout') ||
    normalized.includes('/account/refresh-session') ||
    normalized.includes('/account/reset-password')
    || normalized.includes('/client-diagnostics')
  );
}
